export enum ProductType {
    Food = 1,
    Paper = 2,
    Expenses = 3
}